import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content
 * Uses same sanitization rules as RichTextEditor for consistency
 */
export const sanitizeHTML = (content: string): string => {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ['p', 'b', 'i', 'br', 'strong', 'em', 'u', 'ol', 'ul', 'li', 'span', 'div'],
    ALLOWED_ATTR: ['class', 'style'],
  });
};
